export default {
  header: 'Make all the right money moves',
  content:
    'Looking for objective advice, expert info, and helpful tools to answer your money questions? Turn to the Nerds.',
};
